import styled from '@emotion/styled'

export const CategoryDescription = styled.div`
    display: flex;
    flex-direction: column;
`
